var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMyobSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "43px",
    height: "17px",
    viewBox: "0 0 41 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 19.503,
    x2: 95.321,
    y2: 19.503,
    gradientTransform: "matrix(0.427083,0,0,0.435897,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "rgb(38.039216%,0%,64.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    style: {
      stopColor: "rgb(43.921569%,0.392157%,62.745098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "rgb(59.607843%,0.784314%,57.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    style: {
      stopColor: "rgb(85.098039%,1.960784%,49.411765%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(92.941176%,2.352941%,46.666667%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 19.503,
    x2: 95.321,
    y2: 19.503,
    gradientTransform: "matrix(0.427083,0,0,0.435897,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "rgb(38.039216%,0%,64.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    style: {
      stopColor: "rgb(43.921569%,0.392157%,62.745098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "rgb(59.607843%,0.784314%,57.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    style: {
      stopColor: "rgb(85.098039%,1.960784%,49.411765%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(92.941176%,2.352941%,46.666667%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 19.503,
    x2: 95.321,
    y2: 19.503,
    gradientTransform: "matrix(0.427083,0,0,0.435897,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "rgb(38.039216%,0%,64.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    style: {
      stopColor: "rgb(43.921569%,0.392157%,62.745098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "rgb(59.607843%,0.784314%,57.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    style: {
      stopColor: "rgb(85.098039%,1.960784%,49.411765%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(92.941176%,2.352941%,46.666667%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 19.503,
    x2: 95.321,
    y2: 19.503,
    gradientTransform: "matrix(0.427083,0,0,0.435897,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "rgb(38.039216%,0%,64.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    style: {
      stopColor: "rgb(43.921569%,0.392157%,62.745098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "rgb(59.607843%,0.784314%,57.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    style: {
      stopColor: "rgb(85.098039%,1.960784%,49.411765%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(92.941176%,2.352941%,46.666667%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 6.722656 4.996094 C 6.089844 4.222656 5.128906 3.738281 3.933594 3.738281 C 1.550781 3.722656 0 5.449219 0 7.695312 L 0 12.851562 L 0.734375 12.851562 C 1.234375 12.824219 2.210938 12.574219 2.238281 11.101562 L 2.238281 7.652344 C 2.238281 6.644531 2.929688 5.957031 3.933594 5.957031 C 5.414062 5.957031 5.570312 7.15625 5.570312 7.652344 L 5.570312 12.851562 L 6.304688 12.851562 C 6.792969 12.824219 7.769531 12.574219 7.8125 11.113281 L 7.8125 7.652344 C 7.8125 6.644531 8.53125 5.957031 9.507812 5.957031 C 10.988281 5.957031 11.160156 7.15625 11.160156 7.652344 L 11.160156 12.851562 L 11.890625 12.851562 C 12.394531 12.824219 13.386719 12.574219 13.398438 11.070312 L 13.398438 7.695312 C 13.398438 5.359375 11.949219 3.722656 9.507812 3.722656 C 8.371094 3.722656 7.382812 4.222656 6.722656 4.996094 Z M 6.722656 4.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 19.863281 4.9375 L 17.980469 10.253906 L 15.925781 4.746094 C 15.609375 3.871094 14.804688 3.929688 14.804688 3.929688 L 13.054688 3.929688 L 16.53125 12.574219 C 16.53125 12.558594 16.53125 12.558594 16.515625 12.546875 C 16.515625 12.546875 16.515625 12.558594 16.53125 12.574219 C 16.53125 12.589844 16.542969 12.605469 16.542969 12.605469 L 16.53125 12.558594 C 16.644531 12.910156 16.617188 13.101562 16.5 13.449219 L 16.429688 13.667969 C 16.027344 14.691406 15.453125 14.96875 14.246094 14.894531 L 14.246094 14.910156 L 15.078125 17 C 16.628906 16.972656 17.808594 16.445312 18.585938 14.472656 L 22.761719 3.929688 L 21.199219 3.929688 C 21.125 3.929688 20.234375 3.957031 19.863281 4.9375 Z M 19.863281 4.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 24.429688 8.425781 C 24.429688 6.894531 25.390625 5.8125 26.582031 5.8125 C 27.773438 5.8125 28.738281 6.878906 28.738281 8.425781 C 28.738281 9.929688 27.773438 10.96875 26.582031 10.96875 C 25.390625 10.96875 24.429688 9.929688 24.429688 8.425781 Z M 22.1875 8.414062 C 22.1875 11.070312 24.15625 13.058594 26.582031 13.058594 C 29.011719 13.058594 30.992188 11.070312 30.992188 8.414062 C 30.992188 5.753906 29.011719 3.738281 26.582031 3.738281 C 24.15625 3.722656 22.1875 5.753906 22.1875 8.414062 Z M 22.1875 8.414062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 33.980469 8.425781 C 33.980469 7.011719 34.984375 5.871094 36.21875 5.871094 C 37.457031 5.871094 38.460938 6.980469 38.460938 8.425781 C 38.460938 9.84375 37.457031 10.925781 36.21875 10.925781 C 34.984375 10.9375 33.980469 9.8125 33.980469 8.425781 Z M 33.519531 0 C 31.996094 0 31.753906 1.050781 31.726562 1.546875 L 31.726562 12.851562 L 32.800781 12.851562 C 33.664062 12.867188 33.863281 12.3125 33.878906 11.992188 L 33.878906 11.902344 C 34.554688 12.632812 35.488281 13.042969 36.550781 13.042969 C 38.847656 13.042969 40.714844 11.042969 40.714844 8.414062 C 40.714844 5.769531 38.847656 3.769531 36.550781 3.769531 C 35.546875 3.769531 34.65625 4.148438 33.980469 4.804688 L 33.980469 0 Z M 33.519531 0 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMyobSm);
export default __webpack_public_path__ + "static/media/logo-myob-sm.b638b31df735342ef96bbdba112fa48a.svg";
export { ForwardRef as ReactComponent };